import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import * as firestore from "firebase/firestore";
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

// Configuration from environment variables
const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID
};

// Defensive initialization for app
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
const auth = getAuth(app);
const storage = getStorage(app);

// Firestore initialization (Robust connection config to resolve QUIC_PROTOCOL_ERROR & ERR_INTERNET_DISCONNECTED)
const db = initializeFirestore(app, {
    experimentalForceLongPolling: true,
    useFetchStreams: false // More compatible with certain proxy/VPN setups
});

// Modular functions proxies
const { 
    collection, doc, getDoc, getDocs, setDoc, updateDoc, 
    addDoc, deleteDoc, onSnapshot, query, where, orderBy, 
    limit, increment, serverTimestamp, runTransaction, writeBatch,
    getCountFromServer, startAfter
} = firestore;

export { 
    auth, db, storage, firebaseConfig,
    ref, uploadBytesResumable, getDownloadURL,
    collection, doc, getDoc, getDocs, setDoc, updateDoc, 
    addDoc, deleteDoc, onSnapshot, query, where, orderBy, 
    limit, increment, serverTimestamp, runTransaction, writeBatch,
    getCountFromServer, startAfter
};
export default app;
